import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { services, PHONE_DISPLAY, PHONE_TEL, EMAIL } from "../data/services";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy-deep noise-dark text-white overflow-hidden">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 pt-20 pb-10 relative z-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
        <div className="md:col-span-5">
          <div className="inline-flex items-center bg-white px-4 py-3 mb-8">
            <img
              src="/logo-full.png"
              alt="Way2Go Transport Co."
              data-testid="footer-logo"
              className="h-24 w-auto"
              onError={(e) => {
                e.currentTarget.src = "/logo.jpg";
              }}
            />
          </div>
          <p className="text-white/60 text-sm leading-relaxed max-w-sm font-medium">
            Way2Go Transport Co. — nationwide expedited freight by ground and air.
            Two-hour pickup, live humans around the clock, and one motto: yes we do.
          </p>
          <div className="mt-8 space-y-3">
            <a
              href={PHONE_TEL}
              data-testid="footer-phone"
              className="flex items-center gap-3 font-mono text-lg font-bold text-white hover:text-volt transition-colors duration-200"
            >
              <Phone size={18} className="text-volt" /> {PHONE_DISPLAY}
              <span className="text-white/40 text-sm">24/7 dispatch</span>
            </a>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email"
              className="flex items-center gap-3 font-mono text-sm text-white/70 hover:text-volt transition-colors duration-200"
            >
              <Mail size={16} className="text-volt" /> {EMAIL}
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-volt mb-6">Services</p>
          <ul className="space-y-3">
            {services.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`footer-service-${s.slug}`}
                  className="group flex items-center gap-1 text-sm font-semibold text-white/70 hover:text-white transition-colors duration-200"
                >
                  {s.name}
                  <ArrowUpRight size={13} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-200 text-volt" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-volt mb-6">Company</p>
          <ul className="space-y-3">
            <li><Link to="/#services" data-testid="footer-link-services" className="text-sm font-semibold text-white/70 hover:text-white transition-colors duration-200">Services</Link></li>
            <li><Link to="/#calculator" data-testid="footer-link-estimator" className="text-sm font-semibold text-white/70 hover:text-white transition-colors duration-200">Time Estimator</Link></li>
            <li><Link to="/#fleet" data-testid="footer-link-fleet" className="text-sm font-semibold text-white/70 hover:text-white transition-colors duration-200">Fleet</Link></li>
            <li><Link to="/#reviews" data-testid="footer-link-reviews" className="text-sm font-semibold text-white/70 hover:text-white transition-colors duration-200">Reviews</Link></li>
            <li><Link to="/about" data-testid="footer-link-about" className="text-sm font-semibold text-white/70 hover:text-white transition-colors duration-200">About Us</Link></li>
            <li><Link to="/quote" data-testid="footer-link-quote" className="text-sm font-semibold text-white/70 hover:text-white transition-colors duration-200">Get a Quote</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="text-sm font-semibold text-white/70 hover:text-white transition-colors duration-200">Contact Us</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-volt mb-6">Dispatch</p>
          <p className="text-sm font-semibold text-white/70 leading-relaxed">
            24 hours a day<br />7 days a week<br />365 days a year<br />Nationwide, USA
          </p>
        </div>
      </div>
    </div>

    <div className="relative z-10 select-none" aria-hidden="true">
      <p className="font-display font-black uppercase leading-[0.8] text-center text-outline text-[19vw] tracking-tight -mb-[3vw]">
        WAY2GO
      </p>
    </div>

    <div className="relative z-10 border-t border-white/10">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[11px] tracking-widest text-white/40 uppercase">
          © 2026 Way2Go Transport Co. All rights reserved.
        </p>
        <p className="font-mono text-[11px] tracking-widest text-white/40 uppercase">
          Ground · Air · Nationwide · 24/7
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
